import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { IncludeContent } from 'bricks/IncludeContent';
import { RFCheckbox, RFTextInput } from 'bricks/ReduxForm';
import { Heading } from 'components';
import {
  SUBSCRIBE_FORM_FIELD_AGREEMENT,
  SUBSCRIBE_FORM_FIELD_EMAIL,
} from 'store/widgets/SubscribeForm/constants';
import { getSubscribeFormAgreementDataUrl } from 'store/widgets/SubscribeForm/selectors';

import AsyncPopupTextLink from '../../../AsyncPopupTextLink';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/* Styled and connected component for use in IncludeContent */
const AsyncStyledLink = ({ children, contentRequestUrl }) => (
  <AsyncPopupTextLink className={cx('link')} contentRequestUrl={contentRequestUrl}>
    <span className={cx('linkText')}>{children}</span>
  </AsyncPopupTextLink>
);

AsyncStyledLink.propTypes = {
  children: PropTypes.any,
  contentRequestUrl: PropTypes.string,
};

const AgreementTextLink = connect((state) => ({
  contentRequestUrl: getSubscribeFormAgreementDataUrl(state),
}))(AsyncStyledLink);

export default function InitView({
  agreementTextTemplate,
  buttonText,
  className,
  description,
  formId,
  heading,
  headingTagName,
  isAgreementUnchecked,
  isColumn,
  isMobile,
  isNestedWidget,
  markup,
  onToogleAgreement,
  title,
}) {
  return (
    <div className={cx('wrapper', className, { isColumn, isMobile, isNestedWidget })}>
      <div className={cx('content', { isColumn, isMobile }, 'wrapperCell')}>
        {heading ?
          <Heading
            className={cx('heading', { isColumn, isMobile })}
            level={isMobile ? 4 : 3}
            tagName={headingTagName}
          >
            {heading}
          </Heading>
        : null}
        {markup ?
          <IncludeContent htmlContent={markup} />
        : null}
        {description ?
          <span className={cx('description', { isMobile })}>{description}</span>
        : null}
        {title ?
          <span className={cx('title', { isMobile })}>{title}</span>
        : null}
      </div>
      <div className={cx('wrapperCell')}>
        <div className={cx('input', { isColumn, isMobile })}>
          <Field
            className={cx('inputField', 'inputCell', { isColumn, isMobile })}
            component={RFTextInput}
            name={SUBSCRIBE_FORM_FIELD_EMAIL}
            placeholder="Электронная почта"
          />
          <div className={cx('buttonWrapper', 'inputCell', { isColumn, isMobile })}>
            <Button isDisabled={isAgreementUnchecked} isWide size="m" type="submit">
              {buttonText}
            </Button>
          </div>
        </div>
        <Field
          className={cx('agreement', { isColumn, isMobile })}
          component={RFCheckbox}
          name={SUBSCRIBE_FORM_FIELD_AGREEMENT}
          onChange={(_, newValue) => {
            onToogleAgreement({ [formId]: !newValue });
          }}
          props={{ name: formId }}
        >
          <span className={cx('agreementText', { isMobile })}>
            <IncludeContent
              htmlContent={agreementTextTemplate || ''}
              replaceTags={{ AgreementTextLink }}
            />
          </span>
        </Field>
      </div>
    </div>
  );
}

InitView.propTypes = {
  agreementTextTemplate: PropTypes.string,
  buttonText: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string,
  formId: PropTypes.string,
  heading: PropTypes.string,
  headingTagName: PropTypes.string,
  isAgreementUnchecked: PropTypes.bool,
  isColumn: PropTypes.bool,
  isMobile: PropTypes.bool,
  /* content props */
  isNestedWidget: PropTypes.bool,
  markup: PropTypes.any,
  /* agreement props */
  onToogleAgreement: PropTypes.func,
  title: PropTypes.string,
};
